import { getFilterCompanyId } from 'appRedux/selectors/utility';

export const getFormattedParams = (filters) => ({
  start_date: filters.startDate,
  end_date: filters.endDate,
  page: filters.page,
  per_page: filters.perPage,
  company_id: getFilterCompanyId(filters),
});
